function animationClassesGenerator(classes) {
  var _classes$enter = classes.enter,
    enterFrom = _classes$enter.from,
    enterTo = _classes$enter.to,
    enterTrans = _classes$enter.transition;
  var _classes$exit = classes.exit,
    exitFrom = _classes$exit.from,
    exitTo = _classes$exit.to,
    exitTrans = _classes$exit.transition;
  var enterFromClasses = enterFrom.split(' ');
  var exitFromClasses = exitFrom.split(' ');
  var enterTransitionAndToClasses = enterTrans.split(' ').concat(enterTo.split(' '));
  var exitTransitionAndToClasses = exitTrans.split(' ').concat(exitTo.split(' '));
  return function getNodeAnimationClasses(state) {
    var classesToAdd = [];
    var classesToRemove = [];
    if (state === 'enter') {
      classesToAdd = enterFromClasses;
    } else if (state === 'entering') {
      classesToRemove = enterFromClasses;
      classesToAdd = enterTransitionAndToClasses;
    } else if (state === 'entered') {
      classesToRemove = enterTransitionAndToClasses;
    } else if (state === 'exit') {
      classesToAdd = exitFromClasses;
    } else if (state === 'exiting') {
      classesToRemove = exitFromClasses;
      classesToAdd = exitTransitionAndToClasses;
    } else if (state === 'exited') {
      classesToRemove = exitTransitionAndToClasses;
    }
    return {
      classesToAdd: classesToAdd,
      classesToRemove: classesToRemove
    };
  };
}

export { animationClassesGenerator };
//# sourceMappingURL=utils.js.map
